export type StripePayoutPreference = 'shared' | 'separate';

const PREFERENCE_KEY = 'podium_stripe_payout_preference';

export function getStripePayoutPreference(): StripePayoutPreference | null {
  try {
    const value = localStorage.getItem(PREFERENCE_KEY);
    if (value === 'shared' || value === 'separate') return value;
    return null;
  } catch {
    return null;
  }
}

export function setStripePayoutPreference(preference: StripePayoutPreference) {
  try {
    localStorage.setItem(PREFERENCE_KEY, preference);
  } catch {
    // ignore
  }
}
